import { render, staticRenderFns } from "./ColorBar.vue?vue&type=template&id=5182f072"
import script from "./ColorBar.vue?vue&type=script&lang=js"
export * from "./ColorBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports